import styled from 'styled-components';
import { Checkbox } from '../../common/components/fields/Checkbox/Checkbox';
import { BookingFormBreakPoints as BreakPoints } from '../../common/styles/BreakPoints';
import { ThemeColours } from '../../common/styles/ThemeColours';
import { FONT_STACK, PRESSABLE } from '../../common/styles/constants';

export const StyledTerms = styled(Checkbox)`
  margin: 24px 0 40px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;

  & > :not(:last-child) {
    margin-inline-end: 10px;

    @media (max-width: ${BreakPoints.SMALL_MAX}px) {
      margin-inline-end: 0;
      margin-bottom: 10px;
    }
  }
`;

export const Paragraph = styled.p`
  ${FONT_STACK};
  color: ${ThemeColours.mono700};
  font-size: 16px;
  line-height: 24px;
  margin: 0 0 24px;
`;

export const Link = styled.a`
  ${PRESSABLE}
  color: ${ThemeColours.primary};
  text-decoration: none;
  user-select: auto;
`;

export const ErrorMessage = styled.div`
  ${FONT_STACK}
  color: ${ThemeColours.negative};
  font-size: 16px;
  line-height: 24px;
  margin-top: 15px;
  text-align: right;

  @media (max-width: ${BreakPoints.SMALL_MAX}px) {
    text-align: left;
  }
`;
